import React from 'react';
import { useSelector } from 'react-redux';
import MailingRuleList from 'components/MailingRuleList';
import MailingRuleRegister from 'components/MailingRuleRegister';
import { RootState } from 'store';
import { FORM_MODE } from 'shared/enums';

const MailingRule: React.FC = () => {
  const { mode } = useSelector(
    (state: RootState) => state.selectedMailingRuleModeNavigation,
  );

  const editMode = [FORM_MODE.create, FORM_MODE.edit, FORM_MODE.view];

  return (
    <React.Fragment>
      {mode === FORM_MODE.list && <MailingRuleList />}
      {editMode.includes(mode) && <MailingRuleRegister />}
    </React.Fragment>
  );
};

export default MailingRule;
